<template>
<div class="chapter">
<div class="inner_page">
<h2 class="toc-title">Table of Contents</h2>
<p class="toc-fm"><a href="#/xhtml/fm01"><span class="aitalic">Preface</span></a></p>
<p class="toc-fm"><a href="#/xhtml/fm02"><span class="aitalic">Foreword</span></a></p>
<p class="toc-fm"><a href="#/xhtml/fm03"><span class="aitalic">Introduction</span></a></p>
<p class="toc-part"><span href="#/xhtml/part01" title="Link target outside of Sample"><span class="abold"><span class="tno">PART ONE:</span> THE PROBLEM WITH WORKPLACE MENTAL HEALTH</span></span></p>
<p class="toc-chap"><span href="#/xhtml/chap01" title="Link target outside of Sample">1. What is a Mental Illness?</span></p>
<p class="toc-chap"><span href="#/xhtml/chap02" title="Link target outside of Sample">2. Identifying Mental Health Issues</span></p>
<p class="toc-chap"><span href="#/xhtml/chap03" title="Link target outside of Sample">3. The Costs and Causes of Worsening Mental Health in the Workplace</span></p>
<p class="toc-chap"><span href="#/xhtml/chap04" title="Link target outside of Sample">4. The Manager’s Role</span></p>
<p class="toc-part"><span href="#/xhtml/part02" title="Link target outside of Sample"><span class="abold"><span class="tno">PART TWO:</span> THE 7 PILLARS OF A MENTALLY WEALTHY WORKPLACE</span></span></p>
<p class="toc-chap"><span href="#/xhtml/chap05" title="Link target outside of Sample">What is Mental Wealth?</span></p>
<p class="toc-chap"><span href="#/xhtml/chap06" title="Link target outside of Sample">Pillar 1: We Not You</span></p>
<p class="toc-chap"><span href="#/xhtml/chap07" title="Link target outside of Sample">Pillar 2: Organisational Plasticity</span></p>
<p class="toc-chap"><span href="#/xhtml/chap08" title="Link target outside of Sample">Pillar 3: Nothing About Me Without Me</span></p>
<p class="toc-chap"><span href="#/xhtml/chap09" title="Link target outside of Sample">Pillar 4: Total Integration</span></p>
<p class="toc-chap"><span href="#/xhtml/chap10" title="Link target outside of Sample">Pillar 5: Mutual Responsibility</span></p>
<p class="toc-chap"><span href="#/xhtml/chap11" title="Link target outside of Sample">Pillar 6: Understanding Complexity</span></p>
<p class="toc-chap"><span href="#/xhtml/chap12" title="Link target outside of Sample">Pillar 7: Wrap-around Strategies</span></p>
<p class="toc-chap"><span href="#/xhtml/chap13" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc-chapt"><span href="#/xhtml/bm01" title="Link target outside of Sample"><span class="aitalic">About the Authors And the Workplace Mental Health Institute</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?7e3eb48f